var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('swiper-btn-wrap', _vm._b({
    staticClass: "swiper-btn-wrap--bottom swiper-btn-wrap--right"
  }, 'swiper-btn-wrap', _vm.$attrs, false), [_vm._t("default")], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }